import { Helmet } from 'react-helmet-async';
import { useTranslation } from 'react-i18next';
import { BillingOrderListView } from '@/sections/administrative/accounts/billing-orders/views/billing-order-list-view';

export default function BillingOrderListPage() {
  const { t } = useTranslation();

  return (
    <>
      <Helmet>
        <title>{t('Billing Orders')} | Orion</title>
      </Helmet>

      <BillingOrderListView />
    </>
  );
}
